export default __webpack_public_path__ + "static/media/h3-2.74f82744.jpg";